<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add IP Asset:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    
                     

                     <!-- <v-textarea 
                    outline 
                    :label="descriptionofaasofferingLabeltext" 
                    v-model="descriptionofaasoffering" 
                    :hint="descriptionofaasofferingHint" 
                    :rules="textInputRules"></v-textarea> -->

                    <v-select
                        v-model="iptype"
                        :items="iptypes"
                        :label="iptypeLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select>

                    <v-textarea 
                    outline 
                    :label="ipartefactsLabeltext" 
                    v-model="ipartefacts" 
                    :hint="ipartefactsHint" 
                    :rules="textInputRules"></v-textarea>


                    <v-textarea 
                    outline 
                    :label="ipadditionaldetailsLabelText" 
                    v-model="ipadditionaldetails" 
                    :hint="ipadditionaldetailsHint" 
                    :rules="textInputRules"></v-textarea>

                    <!-- <v-select
                        v-model="aasofferingpercentagebenefitdefault"
                        :items="aasofferingpercentagebenefitrange"
                        :label="aasofferingpercentagebenefitLabelText"
                        :rules="selectInputRules" 
                        outline
                        ></v-select> -->

                    <!-- <v-checkbox v-model="featureavailableinacompetingproduct" :label="featureavailableinacompetingproductLabeltext"></v-checkbox>  -->

                                        <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Detail</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add IP Asset</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            ipartefacts: 'The code behind the application',
            ipartefactsLabelText: 'What are the artefacts which can be considered protectable under this?',
            ipartefactsHint: 'Include all the protectable assests one after another separated by a comma',
            ipadditionaldetails: 'Blogs written by the marketing team can also be included in this section at a later date',
            ipadditionaldetailsLabelText: 'Additional details:',
            ipadditionaldetailsHint: 'If any additional notes needs to be included, please add it in this section.',
             


            iptype: 'Copyright',
            iptypes: ['Contract', 'Copyright', 'Trademark', 'Trade secret', 'Patent'],
            iptypeLabelText: 'What is the nature of intellectual property you are trying to protect?',
 
           
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const aasservice = {
                iptype: this.iptype,
                ipartefacts: this.ipartefacts,
                ipadditionaldetails: this.ipadditionaldetails
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('ipproperties');

        dbref.add(aasservice).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('ipadded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
